import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {AccountSubscriptionType} from "@/lib/types/accounts.ts";
import {AccountUsageTable} from "@/pages/accounts/account-usage/AccountUsageTable.tsx";
import {BillingTab} from "@/pages/billing/BillingPage.tsx";
import {ManageAddons} from "@/pages/billing/manage-addons/ManageAddons.tsx";
import {SubscriptionSummary} from "@/pages/billing/subscription-summary/SubscriptionSummary.tsx";
import {Subscription as Subscription_1_0} from "@/pages/billing/subscription/Subscription.tsx";
import {Subscriptions as Subscription_2_0} from "@/pages/billing/v2/subscriptions/Subscriptions.tsx";

export const BillingTabs = ({activeTab}: {activeTab: BillingTab}) => {
  const {user} = useCurrentUserContext();
  return (
    <>
      {[BillingTab.MANAGE_SUBSCRIPTION, BillingTab.SUBSCRIBE].includes(activeTab) &&
        user?.account.subscription_type === AccountSubscriptionType.BILLING_1_0 && <Subscription_1_0 />}
      {[BillingTab.MANAGE_SUBSCRIPTION, BillingTab.SUBSCRIBE, BillingTab.MANAGE_ADDONS].includes(activeTab) &&
        user?.account.subscription_type === AccountSubscriptionType.BILLING_2_0 && <Subscription_2_0 />}
      {activeTab === BillingTab.MANAGE_ADDONS &&
        user?.account.subscription_type === AccountSubscriptionType.BILLING_1_0 && <ManageAddons />}
      {[BillingTab.INVOICES, BillingTab.PAYMENT_METHOD, BillingTab.SUBSCRIPTION_SUMMARY].includes(activeTab) && (
        <SubscriptionSummary />
      )}
      {activeTab === BillingTab.ACCOUNT_USAGE && <AccountUsageTable />}
    </>
  );
};
